import services from "@/http";
import * as types from "./mutation-types";
import * as storage from "../storage";

export const ActionGetAll = async ({ dispatch }, payload) => {
  await services.estados.get_all(payload).then((res) => {
    dispatch("ActionSetEstados", res.data.data);
    dispatch("ActionSetPagination", res.data.meta);
  });
};

export const ActionShow = async ({ dispatch }, payload) => {
  await services.estados.show(payload).then((res) => {
    dispatch("ActionSetEstado", res.data.estado);
  });
};

export const ActionFindById = async (store, id) => {
  var estado = {};
  await services.estados.show({ id: id }).then((res) => {
    estado = res.data.estado;
  });
  return estado;
};

export const ActionStore = async ({ commit }, payload) => {
  await services.estados.store(payload).then((res) => {
    commit(types.SET_ESTADO, res.data.estado);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.estados.update(payload).then((res) => {
    commit(types.SET_ESTADO, res.data.estado);
  });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.estados.delete({ id: id }).then(() => {
    commit(types.SET_ESTADO, null);
  });
};

export const ActionSetEstados = ({ commit }, payload) => {
  commit(types.SET_ESTADOS, payload);
  storage.setEstados(payload);
};

export const ActionSetEstado = ({ commit }, payload) => {
  commit(types.SET_ESTADO, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionFind = async (store, search) => {
  const estados = storage.getEstados();
  if (!estados.length) {
    await services.estados.get_all({ q: search }).then((res) => {
      estados = res.data.data;
    });
  }
  return estados;
};
